/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityDto
 */
export interface IdentityDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    subjectCN?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    issuerCN?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    alias?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    thumbPrint?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    state?: string;
    /**
     * 
     * @type {Date}
     * @memberof IdentityDto
     */
    validTo?: Date;
}

export function IdentityDtoFromJSON(json: any): IdentityDto {
    return IdentityDtoFromJSONTyped(json, false);
}

export function IdentityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectCN': !exists(json, 'subjectCN') ? undefined : json['subjectCN'],
        'issuerCN': !exists(json, 'issuerCN') ? undefined : json['issuerCN'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'thumbPrint': !exists(json, 'thumbPrint') ? undefined : json['thumbPrint'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'validTo': !exists(json, 'validTo') ? undefined : (new Date(json['validTo'])),
    };
}

export function IdentityDtoToJSON(value?: IdentityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectCN': value.subjectCN,
        'issuerCN': value.issuerCN,
        'type': value.type,
        'groupName': value.groupName,
        'alias': value.alias,
        'thumbPrint': value.thumbPrint,
        'state': value.state,
        'validTo': value.validTo === undefined ? undefined : (value.validTo.toISOString().substr(0,10)),
    };
}

